export default __webpack_public_path__ + "static/media/Gift.55030a75.svg";